import React from "react";
import { create } from "zustand";
import DataListStore from "../../store/DataListStore";
import ListViewV2 from "../App/DataListV2";
import { UpdateStatusPesanan } from "services/datalist/datalist-api";
import { notification, Space } from "antd";

import { CloseCircleOutlined } from "@ant-design/icons";
import { ClickLoadingButton } from "components/buttons/ClickLoadingButton";

const defaultDataStore = create(DataListStore);

const ListBayarManual = () => {
  let user = localStorage.getItem("auth-id");
  const userObj = JSON.parse(user);

  return (
    <ListViewV2
      viewId={"bayarmanual"}
      store={defaultDataStore}
      customRowAction={(props) => (
        <Space style={{ display: "flex", justifyContent: "left" }}>
          <ClickLoadingButton
            danger
            title="Cancel Pembayaran"
            onClick={async () => {
              if (window.confirm("Cancel Pembayaran ?")) {
                var data = {
                  sesionId: props.data.SesionID,
                  sequence: props.data.No,
                  user: userObj.firstName,
                  action: "CANCEL BAYAR",
                };
                const { affect } = await UpdateStatusPesanan(data);

                if (affect && affect > 0) {
                  notification.success({
                    message: "Update Status Pesanan",
                    description: "Status pesanan berhasil di update",
                  });
                } else {
                  notification.error({
                    message: "Update Status Pesanan",
                    description:
                      "Status pesanan gagal diupdate. Coba lagi nanti",
                  });
                }
              }
            }}
          >
            <Space>
              <CloseCircleOutlined />
            </Space>
          </ClickLoadingButton>
        </Space>
      )}
      hideEdit
    />
  );
};

export default ListBayarManual;
